module.exports = __webpack_public_path__ + "website-graphic.538032.svg";